import has from 'lodash/has';

import type { Brand } from 'src/App/generated/graphql-types';
import type { NewBrand } from 'src/types';

export const isExistingBrand = (brand: Brand | NewBrand): brand is Brand =>
  brand && has(brand, 'id');
